import { motion } from "motion/react";
import { Check } from "lucide-react";
import { PricingPackage } from "../../data/pricing-data";

interface PricingCardProps {
  pkg: PricingPackage;
  index: number;
}

export function PricingCard({ pkg, index }: PricingCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      className={`relative bg-gradient-to-br from-violet-950/40 via-fuchsia-950/40 to-cyan-950/40 rounded-3xl p-8 border ${
        pkg.popular ? 'border-fuchsia-400/50 ring-2 ring-fuchsia-500/30' : 'border-violet-500/20'
      } hover:border-violet-400/50 transition-all duration-300`}
    >
      {pkg.popular && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1 bg-gradient-to-r from-fuchsia-500 to-pink-500 rounded-full text-sm font-bold">
          Most Popular
        </div>
      )}
      
      <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${pkg.color} flex items-center justify-center mb-6`}>
        <pkg.icon className="w-7 h-7 text-white" />
      </div>

      <h3 className="text-2xl font-bold mb-2 text-white">{pkg.name}</h3>
      <div className="flex items-baseline gap-2 mb-4">
        <span className={`text-4xl font-bold bg-gradient-to-r ${pkg.color} bg-clip-text text-transparent`}>
          {pkg.price}
        </span>
      </div>
      <p className="text-gray-400 mb-6">{pkg.description}</p>

      <ul className="space-y-3 mb-8">
        {pkg.features.map((feature) => (
          <li key={feature} className="flex items-start gap-2">
            <Check className="w-5 h-5 text-violet-400 flex-shrink-0 mt-0.5" />
            <span className="text-gray-300">{feature}</span>
          </li>
        ))}
      </ul>

      <a
        href="/contact"
        className={`block w-full px-6 py-3 bg-gradient-to-r ${pkg.color} text-white rounded-xl font-semibold text-center hover:shadow-lg hover:shadow-violet-500/50 transition-all duration-300`}
      >
        Get Started
      </a>
    </motion.div>
  );
}